export default "__VITE_ASSET__a9aee039__"